/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  document.addEventListener('click', (event) => {
    const drawerToggle = event.target.closest('[data-drawer-toggle]');
    if (!drawerToggle || event.target === drawerToggle) {
      return;
    }

    // The core drawer handler reads event.target directly, so normalize nested icon clicks.
    event.preventDefault();
    event.stopImmediatePropagation();
    drawerToggle.click();
  }, true);

  const setQuickBuyPosition = (container = document) => {
    const cards = container.querySelectorAll('[data-product-block]');
    cards.forEach((card) => {
      const image = card.querySelector('.product-grid-item__image');
      if (!image) {
        return;
      }

      card.style.setProperty('--product-grid-image-height', `${image.offsetHeight}px`);
    });
  };

  const runSetQuickBuyPosition = () => setQuickBuyPosition(document);

  window.addEventListener('load', runSetQuickBuyPosition);
  window.addEventListener('resize', runSetQuickBuyPosition);
  document.addEventListener('theme:resize', runSetQuickBuyPosition);
  document.addEventListener('theme:section:load', (event) => {
    setQuickBuyPosition(event.target);
  });
  document.addEventListener('theme:section:reorder', runSetQuickBuyPosition);
  document.addEventListener('theme:section:select', runSetQuickBuyPosition);
  document.addEventListener('theme:section:deselect', runSetQuickBuyPosition);

  runSetQuickBuyPosition();
})();

(function() {
  const FOCUSABLE = 'a[href],button:not([disabled]),textarea:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';

  const initLanguagePopup = () => {
    const all = [...document.querySelectorAll('#LanguagePopup')];
    const popup = all.filter((el) => el.parentElement !== document.body).pop() ?? all.pop();

    if (!popup) {
      return;
    }

    all.filter((el) => el !== popup).forEach((stale) => stale.remove());

    if (popup.parentElement !== document.body) {
      document.body.appendChild(popup);
    }

    const dialog = popup.querySelector('.LanguagePopup__Dialog');
    const languageButtons = [...popup.querySelectorAll('.LanguagePopup__Button')];
    const submitBtn = popup.querySelector('[data-language-popup-submit]');
    const localeForm = popup.querySelector('.LanguagePopup__Form');
    const localeInput = popup.querySelector('[name="locale_code"]');
    const returnToInput = popup.querySelector('[name="return_to"]');
    const currentLocale = popup.dataset.locale;

    let selectedLanguage = popup.querySelector('.LanguagePopup__Button.is-active')?.dataset.language ?? currentLocale;
    let lastFocused = null;

    const getFocusable = () => [...dialog.querySelectorAll(FOCUSABLE)].filter((el) => el.offsetParent !== null);

    const onKeydown = (event) => {
      if (event.key === 'Escape') {
        close();
        return;
      }

      if (event.key !== 'Tab') {
        return;
      }

      const focusable = getFocusable();

      if (!focusable.length) {
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const isInside = dialog.contains(document.activeElement);

      if (event.shiftKey) {
        if (!isInside || document.activeElement === first) {
          event.preventDefault();
          last.focus();
        }
      } else if (!isInside || document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    const open = () => {
      lastFocused = document.activeElement;
      popup.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);
      getFocusable()[0]?.focus();
    };

    const close = () => {
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      lastFocused?.focus?.();
    };

    languageButtons.forEach((button) => {
      button.addEventListener('click', () => {
        selectedLanguage = button.dataset.language;
        languageButtons.forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
      });
    });

    popup.querySelectorAll('[data-language-popup-close]').forEach((el) => {
      el.addEventListener('click', close);
    });

    submitBtn?.addEventListener('click', () => {
      if (localeForm && localeInput && selectedLanguage !== currentLocale) {
        localeInput.value = selectedLanguage;

        if (returnToInput) {
          returnToInput.value = window.location.pathname + window.location.search + window.location.hash;
        }

        localeForm.submit();
        return;
      }

      close();
    });

    window.SleepInnovationsLanguagePopup = { open, close };
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-language-selector-open]');

    if (!trigger) {
      return;
    }

    event.preventDefault();

    if (trigger.closest('[data-drawer]')) {
      document.dispatchEvent(new CustomEvent('theme:drawer:closing'));
    }

    const pageSelector = window.SleepInnovationsLanguageSelector;

    if (typeof pageSelector?.open === 'function') {
      pageSelector.open();
      return;
    }

    window.SleepInnovationsLanguagePopup?.open();
  });

  document.addEventListener('theme:section:load', initLanguagePopup);

  initLanguagePopup();
})();
